var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.36093 2.02512L8.57343 6.22512C8.62343 6.27512 8.65893 6.32929 8.67993 6.38762C8.70093 6.44596 8.71126 6.50846 8.71093 6.57512C8.71093 6.64179 8.7006 6.70429 8.67993 6.76262C8.65926 6.82096 8.62376 6.87512 8.57343 6.92512L4.36093 11.1376C4.24426 11.2543 4.09843 11.3126 3.92343 11.3126C3.74843 11.3126 3.59843 11.2501 3.47343 11.1251C3.34843 11.0001 3.28593 10.8543 3.28593 10.6876C3.28593 10.521 3.34843 10.3751 3.47343 10.2501L7.14843 6.57512L3.47343 2.90012C3.35676 2.78346 3.29843 2.63962 3.29843 2.46862C3.29843 2.29762 3.36093 2.14979 3.48593 2.02512C3.61093 1.90012 3.75676 1.83762 3.92343 1.83762C4.0901 1.83762 4.23593 1.90012 4.36093 2.02512Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableArrow);
export default __webpack_public_path__ + "static/media/table-arrow.d087cfa0ec6bece7521cfa77588c5032.svg";
export { ForwardRef as ReactComponent };